import { render, staticRenderFns } from "./Projets.vue?vue&type=template&id=28544372&scoped=true&lang=true&"
import script from "./Projets.vue?vue&type=script&lang=js&"
export * from "./Projets.vue?vue&type=script&lang=js&"
import style0 from "./Projets.vue?vue&type=style&index=0&id=28544372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28544372",
  null
  
)

export default component.exports